import { keyBy, map } from 'lodash';
import { DRAFT, ERROR, SCHEDULED, SENT, } from './NotificationStatus';
const Basic = [DRAFT, SCHEDULED, SENT, ERROR];
const BasicByValue = keyBy(Basic, 'value');
const itemId = ({ value }) => value;
const DefaultValue = map(Basic, itemId);
export default {
    Basic,
    BasicByValue,
    itemId,
    DefaultValue,
};
